import type { TableMessage } from '../api/fetchers/tableLevelMessages/types';
import type { Message } from '../store/slices/chat/types';
import { ChatBlockType, SendType } from '../store/slices/chat/types';

export const LIVE_SUPPORT_WELCOME_MESSAGE: Message = {
  messageId: 'initial_support_chat_message',
  role: 'LIVE_SUPPORT',
  tagMessage: 'SUPPORT',
  content: 'LIVE_WELCOME',
  userId: 'support',
  userScreenName: 'LIVE_SUPPORT',
  requireTranslation: true,
  timestamp: 0, // Display first
  showMessage: true,
};

export const isGameChatRestricted = (
  isBetRequiredToChat: boolean,
  isBetChatAllowed: boolean,
  isLowBalance: boolean,
  hasTotalBet: boolean
): boolean => {
  return isBetRequiredToChat ? !isBetChatAllowed : isLowBalance && !hasTotalBet;
};

export const generateMessage = (
  userId: string,
  input: string,
  tableId: string,
  casinoId: string,
  isGameChat: boolean = false
): Message => ({
  content: input.trim(),
  action: 'COMMAND',
  messageId: `${userId}_${Date.now()}`,
  userId,
  tableId,
  casinoId,
  role: 'GAME_USER',
  tagMessage: isGameChat ? 'GAME_USER' : 'SUPPORT',
  timestamp: Date.now(),
});

export const generateWelcomeMessage = (
  isCrashGame: boolean,
  tableName: string = '',
  dealerName: string = ''
): TableMessage => ({
  messageId: 'dealer_welcome_message',
  role: 'GAME_USER',
  tagMessage: 'GAME_USER',
  content: `WELCOMETO ${tableName}`,
  userId: 'dealer',
  userScreenName: isCrashGame ? undefined : dealerName, // Prevent dealer name from displaying in crash games
  requireTranslation: true,
  timestamp: Date.now(),
  showMessage: true,
  hostManagerId: null,
  hostManagerName: null,
  messageRead: false,
  requestCreatedTimeStamp: null,
  requestStatus: null,
  requestType: null,
  sendToSelected: null,
  toCasinoId: null,
  toCasinoName: null,
  toTableId: null,
  toTableName: null,
  toUserId: null,
  toUserScreenName: null,
});

export const parseSystemMessage = (text: string): string => {
  return text.replace(/<[^>]*>/g, '').trim();
};

// Rename showHide field to showMessage. Remove this after backend introduces showMessage field.
export const parseChatMessage = (message: TableMessage): TableMessage => {
  if (!('showMessage' in message)) {
    message.showMessage = message.showHide;
    delete message.showHide;
  }

  return message;
};

export const createChatAvailableMessage = (betChatAllowed: boolean): Message => {
  const timestamp = Date.now();
  return {
    messageId: `chat_available_message_${timestamp}`,
    role: 'GAME_USER',
    tagMessage: 'GAME_USER',
    content: betChatAllowed ? 'CHAT_AVAILABLE' : 'CHAT_ACTIVATED',
    sendType: SendType.Notification,
    requireTranslation: true,
    timestamp,
    showMessage: true,
  };
};

export const isBetRequiredToChat = (chatBlockType?: ChatBlockType): boolean =>
  chatBlockType === ChatBlockType.BetRequired;
